import { render, staticRenderFns } from "./BigCard.vue?vue&type=template&id=2e90c9e6&scoped=true&"
import script from "./BigCard.vue?vue&type=script&lang=js&"
export * from "./BigCard.vue?vue&type=script&lang=js&"
import style0 from "./BigCard.vue?vue&type=style&index=0&id=2e90c9e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e90c9e6",
  null
  
)

export default component.exports